import styles from '../ReleaseNotesPage.module.css';

export const renderMarkdown = text => {
  return text.split('\n').map((line, i) => {
    if (line.startsWith('### ')) {
      return <h3 key={i}>{line.replace('###', '')}</h3>;
    }
    if (line.startsWith('- ')) {
      return <li key={i}>{line.substring(2)}</li>;
    }
    if (line.trim() === '') {
      return <br key={i} />;
    }
    return (
      <p className={styles.paragraph} key={i}>
        {line}
      </p>
    );
  });
};
